import { PageHeader } from "@/components/common/PageParts";
import { RoadmapSection } from "@/components/roadmap/RoadmapSection";

export default function Roadmap() {
  return (
    <div className="container-x py-12">
      <PageHeader eyebrow="Transparency" title="Platform roadmap" testid="roadmap-header"
        description="Phase 1 is live. Later phases are listed for information only — they are not yet available and have no working controls." />
      <RoadmapSection />
    </div>
  );
}
